var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackPreviewDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 488,
    height: 488,
    rx: 28,
    fill: "#0E0E29",
    stroke: "url(#paint0_linear_636_6745)",
    strokeWidth: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.705 210.303V241.671L369.283 246.388V372.385C369.283 378.075 367.262 383.84 363.743 389.08C358.428 396.941 349.519 403.828 338.364 407.647C316.429 415.283 294.119 408.395 288.504 392.374C282.889 376.278 296.215 357.113 318.15 349.477C324.963 347.081 331.776 346.108 338.139 346.407V218.388L369.283 215.019L412.705 210.303Z",
    fill: "url(#paint1_linear_636_6745)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.044 101V261.286C308.044 266.975 306.023 272.74 302.504 277.981C297.189 285.916 288.28 292.729 277.125 296.547C255.19 304.183 232.88 297.296 227.265 281.275C221.65 265.179 234.976 246.013 256.911 238.377C263.724 235.981 270.537 235.008 276.9 235.308V135.737L180.774 146.144V272.141C180.774 277.831 178.753 283.595 175.234 288.836C169.918 296.697 161.01 303.584 149.855 307.402C127.919 315.039 105.61 308.151 99.9947 292.13C94.3798 276.034 107.706 256.869 129.641 249.232C136.454 246.837 143.267 245.864 149.63 246.163V118.144L180.774 114.775L276.9 104.369L308.044 101Z",
    fill: "url(#paint2_linear_636_6745)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.544 342.739C205.358 342.739 211.693 336.404 211.693 328.589C211.693 320.775 205.358 314.44 197.544 314.44C189.729 314.44 183.394 320.775 183.394 328.589C183.394 336.404 189.729 342.739 197.544 342.739Z",
    fill: "url(#paint3_linear_636_6745)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.12 344.61C271.123 344.61 275.178 340.555 275.178 335.552C275.178 330.549 271.123 326.493 266.12 326.493C261.117 326.493 257.061 330.549 257.061 335.552C257.061 340.555 261.117 344.61 266.12 344.61Z",
    fill: "url(#paint4_linear_636_6745)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.486 122.786C400.489 122.786 404.545 118.73 404.545 113.727C404.545 108.724 400.489 104.668 395.486 104.668C390.483 104.668 386.428 108.724 386.428 113.727C386.428 118.73 390.483 122.786 395.486 122.786Z",
    fill: "url(#paint5_linear_636_6745)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.885 403.828C241.586 403.828 251.072 394.343 251.072 382.642C251.072 370.94 241.586 361.455 229.885 361.455C218.184 361.455 208.698 370.94 208.698 382.642C208.698 394.343 218.184 403.828 229.885 403.828Z",
    fill: "url(#paint6_linear_636_6745)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M355.733 180.357C367.434 180.357 376.92 170.871 376.92 159.17C376.92 147.469 367.434 137.983 355.733 137.983C344.032 137.983 334.546 147.469 334.546 159.17C334.546 170.871 344.032 180.357 355.733 180.357Z",
    fill: "url(#paint7_linear_636_6745)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_636_6745",
    x1: 0.0000115741,
    y1: 512,
    x2: 613.921,
    y2: 201.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A006F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2222AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_636_6745",
    x1: 287.22,
    y1: 410.764,
    x2: 458.952,
    y2: 356.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_636_6745",
    x1: 98.7105,
    y1: 310.52,
    x2: 349.806,
    y2: 183.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_636_6745",
    x1: 183.394,
    y1: 342.739,
    x2: 217.326,
    y2: 325.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_636_6745",
    x1: 257.061,
    y1: 344.61,
    x2: 278.785,
    y2: 333.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_636_6745",
    x1: 386.428,
    y1: 122.786,
    x2: 408.152,
    y2: 111.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_636_6745",
    x1: 208.698,
    y1: 403.828,
    x2: 259.507,
    y2: 378.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_636_6745",
    x1: 334.546,
    y1: 180.357,
    x2: 385.355,
    y2: 154.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#801AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4CFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackPreviewDefault);
export default __webpack_public_path__ + "static/media/track_preview_default.02695bd73afb726eac9b1ca10d5039aa.svg";
export { ForwardRef as ReactComponent };